<div class="container">
    <div class="d-flex gap-2">
<mat-form-field appearance="outline" class="col-md-4 col-sm-12">
  <mat-label>Centre Name</mat-label>
  <mat-select [(ngModel)]="mSelectedCentre" (selectionChange)="onCentreSelected($event)">
    <mat-option *ngFor="let c of centres$|async" [value]="c.centreCode">{{c.centreName}}</mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field appearance="outline" class="col-md-4 col-sm-12">
  <mat-label>Select Child</mat-label>
  <mat-select [(ngModel)]="selectedChildData" (selectionChange)="onChildSelect($event)">
    <mat-option *ngFor="let c of mChildren" [value]="c">{{c.firstName}} {{c.lastName}}</mat-option>
  </mat-select>
</mat-form-field>

      <button mat-mini-fab (click)="searchChildByCode()" ><mat-icon>search</mat-icon></button>
      <button  class="mx-2" mat-mini-fab color="accent" (click)="clearAll()"><mat-icon>clear</mat-icon></button>

    </div>
<div class="card">
  <section class="example-container " tabindex="0">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
                    <h2>Child Case Study</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box"  >
      </li>
    </ul>
    <ul class="header-buttons mr-2 d-flex align-items-center">
      <li class="me-2">  <!-- Bootstrap gap -->
        <button
          mat-mini-fab
          color="primary"
          permission="Case Study"
          [permissionTypes]="[PermissionType.ADD, PermissionType.ALL]"
          (click)="addCaseStudyReport()">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>

      <li>
        <button
          mat-mini-fab
          color="accent"
          (click)="downloadExcel()">
          <mat-icon>download</mat-icon>
        </button>
      </li>
    </ul>

  </div>

  <table mat-table [dataSource]="dataSource" matSort matSortActive="firstName" class="child-table" matSortDisableClear matSortDirection="asc"  >
    <!--  POSITION Column-->
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="#">Sr.</th>
      <td mat-cell *matCellDef="let i = index">
        {{this.paginator1.pageIndex == 0 ? i + 1 : 1 + i + this.paginator1.pageIndex * this.paginator1.pageSize}}
      </td>
    </ng-container>
    <!-- Center Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> State </th>
      <td mat-cell *matCellDef="let element"> {{element.state  }} </td>
    </ng-container>
    <ng-container matColumnDef="centreName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name </th>
      <td mat-cell *matCellDef="let element"> {{element.centreName  }} </td>
    </ng-container>

    <!-- Center Column -->
    <ng-container matColumnDef="happyDischargeDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Happy Discharge Date </th>
      <td mat-cell *matCellDef="let element"> {{(element.dischargeDate)?.toDate() | date:'dd/MM/yyyy' || 'NA'}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="doa">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>DoA </th>
      <td mat-cell *matCellDef="let element"> {{(element.date)?.toDate() | date:'dd/MM/yyyy'}} </td>
    </ng-container>

    <!--      Child Name Column-->
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
      <td mat-cell *matCellDef="let element"> {{element.firstName   }} </td>
    </ng-container>

    <!--      Last Name Column-->
    <ng-container matColumnDef="lastName" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
      <td mat-cell *matCellDef="let element"> {{element.lastName  }} </td>
    </ng-container>
    <ng-container matColumnDef="hospitalname" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Hospital Name </th>
      <td mat-cell *matCellDef="let element"> {{element.hospital  }} </td>
    </ng-container>
    <!-- City Column -->
    <ng-container matColumnDef="city" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header> City </th>
      <td mat-cell *matCellDef="let element">&nbsp; {{element.city}} </td>
    </ng-container>



    <!--     Action-->
    <ng-container matColumnDef="Action">
      <th mat-header-cell *matHeaderCellDef  > Action </th>
      <td mat-cell *matCellDef="let element;let i = index">
        <button mat-icon-button permission="Case Study" [permissionTypes]="[PermissionType.VIEW,PermissionType.ALL]" (click)="ViewReportChildCaseStudy(element.id)" color="primary"><mat-icon>visibility</mat-icon> </button>
        <button mat-icon-button permission="Case Study" [permissionTypes]="[PermissionType.EDIT,PermissionType.ALL]" (click)="editReport(element.id)" color="primary"><mat-icon>edit</mat-icon> </button>
        <button mat-icon-button permission="Case Study" [permissionTypes]="[PermissionType.ARCHIVE,PermissionType.ALL]" (click)="deleteReport(element.id)" color="warn"><mat-icon>delete</mat-icon> </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr *matNoDataRow class="mat-row">
      <!--        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>-->
    </tr>
  </table>
</section>
<mat-paginator [pageSizeOptions]="[20, 50, 100,500]"
               showFirstLastButtons
               aria-label="Select page of periodic elements">
</mat-paginator>
</div>
</div>
